import { DialogComponent } from '@theme/dialog';

if (!customElements.get('flavour-switcher-component')) {
  customElements.define(
    'flavour-switcher-component',
    class FlavourSwitcherComponent extends DialogComponent {
      connectedCallback() {
        super.connectedCallback();

        this.openButton?.addEventListener('click', this.openDrawer);
        this.closeButton?.addEventListener('click', this.closeDialog);

        // warm on pre-click intent (hover/keyboard only; touch pointerdown fires on scroll-start, so touch warms in openDrawer)
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          this.openButton?.addEventListener('pointerenter', this.warmImages, { once: true });
        }
        this.openButton?.addEventListener('focusin', this.warmImages, { once: true });
      }

      disconnectedCallback() {
        this.openButton?.removeEventListener('click', this.openDrawer);
        this.closeButton?.removeEventListener('click', this.closeDialog);

        super.disconnectedCallback();
      }

      get openButton() {
        return this.querySelector('[data-flavour-switcher-trigger]');
      }

      get closeButton() {
        return this.querySelector('[data-flavour-switcher-close]');
      }

      warmImages = () => {
        if (this._warmed) return;
        this._warmed = true;
        // imgs ship src-less (WebKit fetches lazy imgs inside a closed dialog); hover warms all, touch eager-loads 12 and lazy-loads the rest once open
        const eagerLimit = window.matchMedia('(hover: hover) and (pointer: fine)').matches ? Infinity : 12;
        let activated = 0;
        this.querySelectorAll('.flavour-switcher__option-media img[data-src]').forEach((img) => {
          if (activated < eagerLimit) img.loading = 'eager';
          img.src = img.dataset.src;
          activated += 1;
        });
      };

      openDrawer = (event) => {
        event.preventDefault();
        this.warmImages();
        this.showDialog();
      };
    }
  );
}
